module.exports = __webpack_public_path__ + "static/img/sample-data.0a45608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/sample-data.png
// module id = zr5B
// module chunks = 3